import goingEvent from '../../global/goingEvent';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import dhtmlxArray from './dhtmlxArray';
import {t_creator,globalObj} from './dxGridComClass';
import dhtmlDragAndDropObject from '../dhtmlDragAndDropObject';



var dhtmlXGridObject = (function () {
    function dhtmlXGridObject(id) {
        if (goingEvent.initTouch) {
            goingEvent.initTouch();
        }
        /**
         * 很多时候我们要给一些按钮或是img设置背景，
         * 而为了达到数据与表现样式分离的效果，通常背景样式都是在CSS里设定的，
         * 但是这个行为在IE会有一 个Bug，那就是因为 IE默认情况下不缓存背景图片
         * ，所以当鼠标在有CSS背景的按钮或是图片上移动时，图片会闪烁甚至鼠标会出现忙的状态，
         * 而在FireFox下没有这个问 题，为了解决这个问题，有两种解决办法，其一是在CSS中加入如下样式： 其二则就如下 采用js来干预
         */
        if (window._isIE) {
            try {
                document.execCommand("BackgroundImageCache", false, "true");
            } catch (e) {
                console.log(e, "----dhtmlXGridObject--------");
            }
        }
        //初始化表格的 entBox对象 entBox 包含了表头和表体不包含分页
        this._initEntBox(id);
        //经过该修饰器后  该对象拥有了相关事件操作的api
        dhx4._eventable(this);
        var self = this;
        this._RaSeCol = [];
        this.method="POST";
        this._wcorr = 0;
        this.fontWidth = 7;
        this.cell = null;
        this.row = null;
        this.iconURL = "";
        this.editor = null;
        this._f2kE = true;
        this._dclE = true;
        this.combos = new Array(0);
        this.defVal = new Array(0);
        this.rowsAr = {};
        this.rowsBuffer = new dhtmlxArray();
        this.rowsCol = new dhtmlxArray();
        this._data_cache = {};
        this._ecache = {};
        this._ud_enabled = true;
        this.xmlLoader = this.doLoadDetails;
        this._maskArr = [];
        this.selectedRows = new dhtmlxArray();
        this.UserData = {};
        this._sizeFix = this._borderFix = 0;
        //创建表体table对象
        this.obj = t_creator("c_obj");
        //创建表头table对象
        this.hdr = t_creator("c_hdr");
        this.hdr.style.marginRight = "20px";
        this.hdr.style.paddingRight = "20px";
        //创建表体div对象 表体table的父对象
        this.objBox = document.createElement("DIV");
        this.objBox.style.width = "100%";
        this.objBox.style.overflow = "auto";
        this.objBox.appendChild(this.obj);
        this.objBox.className = "objbox";
        if (dhtmlx.$customScroll) {
            dhtmlx.CustomScroll.enable(this);
        }
        //创建表头div对象  表头table对象的父对象
        this.hdrBox = document.createElement("DIV");
        this.hdrBox.style.width = "100%";
        this.hdrBox.style.height = "25px";
        this.hdrBox.style.overflow = "hidden";
        this.hdrBox.className = "xhdr";
        this.preloadImagesAr = new Array(0);
        this.sortImg = document.createElement("DIV");
        this.sortImg.style.display = "none";
        this.hdrBox.appendChild(this.sortImg);
        this.hdrBox.appendChild(this.hdr);
        this.hdrBox.style.position = "relative";
        this.entBox.appendChild(this.hdrBox);
        this.entBox.appendChild(this.objBox);
        this.entBox.grid = this;
        this.objBox.grid = this;
        this.hdrBox.grid = this;
        this.obj.grid = this;
        this.hdr.grid = this;
        this.cellWidthPX = [];
        this.cellWidthPC = [];
        this.cellWidthType = this.entBox.cellwidthtype || "px";
        this.delim = this.entBox.delimiter || ",";
        this._csvDelim = ",";
        this.hdrLabels = [];
        this.columnIds = [];
        this.columnColor = [];
        this._hrrar = [];
        this.cellType = new dhtmlxArray();
        this.cellAlign = [];
        this.initCellWidth = [];
        this.fldSort = [];
        this._srdh =
            window._isIE && document.compatMode != "BackCompat" ? 22 : 20;
        this.imgURL = window.dhx_globalImgPath || "";
        this.isActive = false;
        this.isEditable = true;
        this.useImagesInHeader = false;
        this.pagingOn = false;
        this.rowsBufferOutSize = 0;
        /**
         * 页面丢失时  删除销毁内存
         */
        goingEvent(window, "unload", function () {
            try {
                if (self.destructor) {
                    self.destructor();
                }
            }
            catch (e) {
                console.log(e,"--e-");
            }
        });
        //如果是ie  则设置ajax缓存为false
        if (window._isIE) {
            this.preventIECaching(true);
        }
        //如果存在拖动公共函数 则设置grid的拖动对象
        if (dhtmlDragAndDropObject) {
            this.dragger = new dhtmlDragAndDropObject();
        }
        this._doOnScroll = function (e, mode) {
            this.callEvent("onScroll", [
                this.objBox.scrollLeft,
                this.objBox.scrollTop
            ]);
            this.doOnScroll(e, mode);
        };
        //表格滚动事件
        this.doOnScroll = function (e, mode) {
            this.hdrBox.scrollLeft = this.objBox.scrollLeft;
            if (this.ftr) {
                this.ftr.parentNode.scrollLeft = this.objBox.scrollLeft;
            }
            if (mode) {
                return;
            }
            if (this._srnd) {
                if (this._dLoadTimer) {
                    window.clearTimeout(this._dLoadTimer);
                }
                this._dLoadTimer = window.setTimeout(function () {
                    if (self._update_srnd_view) {
                        self._update_srnd_view();
                    }
                }, 100);
            }
        };
        this._sUDa = false;
        this._sAll = false;
        //表体对象 滚动事件
        this.objBox.onscroll = function () {
            this.grid._doOnScroll();
        };
        //表头对象滚动事件
        this.hdrBox.onscroll = function () {
            if (this._try_header_sync) {
                return;
            }
            this._try_header_sync = true;
            if (Math.abs(this.grid.objBox.scrollLeft - this.scrollLeft) > 1) {
                this.grid.objBox.scrollLeft = this.scrollLeft;
            }
            this._try_header_sync = false;
        };
        if (!window._isOpera || window._OperaRv > 8.5) {
            this.hdr.onmousemove = function (e) {
                this.grid.changeCursorState(e || window.event);
            };
            this.hdr.onmousedown = function (e) {
                return this.grid.startColResize(e || window.event);
            };
        }
        this.obj.onmousemove = this._drawTooltip;
        //表体对象容器div的 单击事件
        this.objBox.onclick = function (e) {
            e = e || event;
            e.cancelBubble = true;
            this.firstChild.grid.setActive(true);
            dhx4.callEvent("_onGridClick", [e, this.firstChild.grid]);
        };
        //表体对象table 单击事件
        this.obj.onclick = function (e) {
            if (this.grid._doClick(e || window.event) !== false) {
                if (this.grid._sclE) {
                    this.grid.editCell(e || window.event);
                }
                else {
                    this.grid.editStop();
                }
            }
            e = e || event;
            e.cancelBubble = true;
            dhx4.callEvent("_onGridClick", [e, this.grid]);
        };
        //如果是mac浏览器
        if (window._isMacOS) {
            this.entBox.oncontextmenu = function (e) {
                e.cancelBubble = true;
                if (e.preventDefault) {
                    e.preventDefault();
                }
                else {
                    e.returnValue = false;
                }
                var that = this.grid;
                if (that._realfake) {
                    that = that._fake;
                }
                return that._doContClick(e || window.event);
            };
        }
        else {
            //注册表格的鼠标点击事件
            this.entBox.onmousedown = function (e) {
                return this.grid._doContClick(e || window.event);
            };
            //注册表格的右键事件
            this.entBox.oncontextmenu = function (e) {
                if (this.grid._ctmndx) {
                    (e || event).cancelBubble = true;
                }
                return !this.grid._ctmndx;
            };
        }
        //表体对象table 的双击事件
        this.obj.ondblclick = function (e) {
            if (!this.grid.wasDblClicked(e || window.event)) {
                return false;
            }
            if (this.grid._dclE) {
                var row = this.grid.getFirstParentOfType(window._isIE ? event.srcElement : e.target, "TR");
                if (row == this.grid.row) {
                    this.grid.editCell(e || window.event);
                }
            }
            (e || event).cancelBubble = true;
            if (window._isOpera) {
                return false;
            }
        };
        //表头单击事件
        this.hdr.onclick = this._onHeaderClick;
        this.sortImg.onclick = function () {
            self._onHeaderClick.apply({ grid: self }, [null, self.r_fldSorted]);
        };
        //表头双击事件
        this.hdr.ondblclick = this._onHeaderDblClick;
        if (!document.body._dhtmlxgrid_onkeydown) {
            goingEvent(document, "keydown", function (e) {
                if (globalObj.globalActiveDHTMLGridObject) {
                    return globalObj.globalActiveDHTMLGridObject.doKey(e || window.event);
                }
            });
            document.body._dhtmlxgrid_onkeydown = true;
        }
        //点击document对象
        goingEvent(document.body, "click", function () {

            if (self.editStop) {

                self.editStop();
            }

            if (self.isActive) {

                self.setActive(false);
            }
        });
        if (this.entBox.style.height.toString().indexOf("%") != -1) {
            this._delta_y = this.entBox.style.height;
        }
        if (this.entBox.style.width.toString().indexOf("%") != -1) {
            this._delta_x = this.entBox.style.width;
        }
        if (this._delta_x || this._delta_y) {
            this._setAutoResize();
        }
        if (dhtmlx.image_path) {
            this.setImagePath(dhtmlx.image_path);
        }
        if (dhtmlx.skin) {
            this.setSkin(dhtmlx.skin);
        }
        return this;
    }
    dhtmlXGridObject.prototype.uid = function () {
        if (!this._ui_seed) {
            this._ui_seed = new Date().valueOf();
        }
        return this._ui_seed++;
    };
    /**
     * 设置ie的缓存
     * @param a
     */
    dhtmlXGridObject.prototype.preventIECaching = function (a) {
        dhx4.ajax.cache = !a;
    };
    /**
     * 根据id来初始化entBox对象
     * @param id
     * @private
     */
    dhtmlXGridObject.prototype._initEntBox = function (id) {
        if (id) {
            if (typeof id == "object") {
                this.entBox = id;
                if (!this.entBox.id) {
                    this.entBox.id = "cgrid2_" + this.uid();
                }
            }
            else {
                this.entBox = document.getElementById(id);
            }
        }
        else {
            this.entBox = document.createElement("DIV");
            this.entBox.id = "cgrid2_" + this.uid();
        }
        this.entBox.innerHTML = "";
        this.entBox.className += " gridbox";
        this.entBox.style.width =
            this.entBox.getAttribute("width") ||
                (window.getComputedStyle
                    ? this.entBox.style.width ||
                        window.getComputedStyle(this.entBox, null)["width"]
                    : this.entBox.currentStyle
                        ? this.entBox.currentStyle.width
                        : this.entBox.style.width || 0) ||
                "100%";
        this.entBox.style.height =
            this.entBox.getAttribute("height") ||
                (window.getComputedStyle
                    ? this.entBox.style.height ||
                        window.getComputedStyle(this.entBox, null)["height"]
                    : this.entBox.currentStyle
                        ? this.entBox.currentStyle.height
                        : this.entBox.style.height || 0) ||
                "100%";
        this.entBox.style.cursor = "default";
        this.entBox.onselectstart = function () {
            return false;
        };
    };
    return dhtmlXGridObject;
})();

export default dhtmlXGridObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dhtmlXGridObject.js